<template>
	<Layout>
		<h1 class="u-a11y-visually-hidden">
			{{ $I18n.trans_choice('payments.subscription', 2) }}
		</h1>
		<NavBack
			:link="backUrl"
			:title="$I18n.trans('commons.back')"
		/>
		<PaymentFlow
			:initial-action="initialAction"
			:initial-qr-code="qrCode"
		/>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import PaymentFlow from '@js/components/Payments/PaymentFlow';
import NavBack from '@js/components/NavBack';
import { mapGetters } from 'vuex';

export default {
	name:       'ViewEvent',
	components: { Layout, PaymentFlow, NavBack },
	props:      {
	},
	data() {
		return {
			backUrl: window.location.protocol + '//' + window.arenaDomain,
		};
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
		}),
		initialAction() {
			const defaultAction = 'checkout';
			const hashValue = window.location.hash.replace('#', '');
			if (!hashValue) return defaultAction;
			return hashValue.split('/')[0] || defaultAction;
		},
		qrCode() {
			return window.location.hash.includes('/qr/')
				? window.location.hash.split('/qr/')[1] || null
				: null;
		},
	},
};
</script>
